module.exports = __webpack_public_path__ + "img/Book_shelf(cube123).0dc805a5.png";